export default __webpack_public_path__ + "static/media/YAS0870.34I-39505_-23386_0.eb20fce4.jpg";